import React, { type ReactNode, useEffect, useRef } from 'react';

import { gsap } from 'gsap';
import { Draggable } from 'gsap/dist/Draggable';

import { InertiaPlugin } from '@pkg/assets/js/gsap-plugins/InertiaPlugin';

import './HorizontalScrollContainer.scss';

gsap.registerPlugin(Draggable, InertiaPlugin);

interface YatHorizontalScrollContainerProps {
    children: ReactNode;
    classes?: string;
    onScroll?: (e) => void | null;
}

const YatHorizontalScrollContainer = ({ children, classes = '', onScroll }: YatHorizontalScrollContainerProps) => {
    const element = useRef() as React.MutableRefObject<HTMLDivElement>;

    useEffect(() => {
        const isTouch = !window.matchMedia('(pointer: fine)').matches;
        const elementRef = element.current;

        if (!isTouch) {
            Draggable.create(elementRef, {
                type: 'scrollLeft',
                inertia: true,
                throwResistance: 2000,
                edgeResistance: 0.8,
                minimumMovement: 5,
            });
        }

        if (onScroll) elementRef.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            if (!isTouch) Draggable.get(elementRef)?.kill();
            if (onScroll) elementRef.removeEventListener('scroll', onScroll);
        };
    }, [element, onScroll]);

    return (
        <div ref={element} className={`yat-horizontal-scroll-container ${classes}`}>
            {children}
        </div>
    );
};

export default YatHorizontalScrollContainer;
